<template>
    <div id="item-ledger-entry-filter">
        <b-row>

            <b-col>
                <v-select size="sm" style="width: 100%;" class="success"
                    :class="searchType == 'MEDICAMENTS' ? 'searchTypeSuccess' : 'searchTypePrimary'"
                    :options="paginated" :filterable="false" @open="onOpen" @close="onClose" label="Description"
                    @search="handleSearch" v-model="selected" ref="select">
                    <template #option="item">

                        <div>
                            <span class="description" v-html="highlightSearchText(item.description)"></span>
                            <span class="links" v-if="search.trim().length >= 4" :key="itemKey">
                                <div class="d-flex align-items-center justify-content-end" style="gap:4px;">
                                    <b-badge variant="light-info" class="sub-badge"
                                        @click.stop.prevent="$emit('substitutionClicked', item)">
                                        <feather-icon icon="RefreshCwIcon" size="10" /> Sub
                                    </b-badge>
                                    <b-badge variant="secondary" v-if="item.inventory == undefined">
                                        <b-spinner small type="grow" />
                                    </b-badge>
                                    <b-badge variant="success" v-else-if="item.inventory">
                                        Stock = {{ item.inventory > 100 ? '+100' : item.inventory }}
                                    </b-badge>
                                    <b-badge variant="danger" v-else>
                                        <feather-icon icon="XIcon" />
                                    </b-badge>
                                </div>
                            </span>
                        </div>
                    </template>

                    <span slot="no-options">

                        <span v-if="search.trim() != ''">
                            <div class="d-flex justify-content-center" v-if="allProducts.length == 0">
                                <b-button variant="primary" disabled class="mr-1" size="sm">
                                    <b-spinner small type="grow" />
                                    chargement en cours
                                    <b-spinner small type="grow" />
                                </b-button>
                            </div>

                            <div class="d-flex justify-content-center" v-else-if="isSearchPending">
                                <b-button variant="primary" disabled class="mr-1" size="sm">
                                    <b-spinner small type="grow" />
                                    recherche…
                                    <b-spinner small type="grow" />
                                </b-button>
                            </div>

                            <div class="d-flex align-items-center" v-else>
                                Désolé, aucun article trouvé
                            </div>

                        </span>
                        <span v-else>
                            <div class="d-flex justify-content-center" v-if="allProducts.length == 0">
                                <b-button variant="primary" disabled class="mr-1" size="sm">
                                    <b-spinner small type="grow" />
                                    chargement en cours
                                    <b-spinner small type="grow" />
                                </b-button>
                            </div>
                        </span>
                    </span>

                    <template #list-footer>
                        <li v-show="hasNextPage && debouncedSearch.trim() != ''" ref="load" class="loader">
                            Chargement plus d'articles...
                        </li>
                    </template>
                </v-select>


            </b-col>

        </b-row>
    </div>
</template>
<script>

import vSelect from 'vue-select'

export default {
    props: {
        searchType: {
            type: String,
            required: true
        },
    },
    components: {
        vSelect
    },
    data() {
        return {
            itemKey: 0,
            selected: null,
            observer: null,
            limit: 10,
            search: '',
            /** Valeur retardée : seul ce texte déclenche filter+sort sur toute la liste (évite 20k×N par frappe). */
            debouncedSearch: '',
            timeout: null,
            searchDebounceTimer: null,
        }
    },
    computed: {
        isNotMobileDevice() {
            return !/Mobi/i.test(navigator.userAgent)
        },
        filtered() {
            const q = this.debouncedSearch.toLowerCase();
            if (this.searchType == "TOUS")
                return this.$store.getters["app-items/geItems"].filter(item => item.description.toLowerCase().indexOf(q) > -1)
                    .sort((a, b) => {
                        const indexA = a.description.toLowerCase().indexOf(q);
                        const indexB = b.description.toLowerCase().indexOf(q);
                        if (indexA === indexB) {
                            return 0;
                        }
                        return indexA < indexB ? -1 : 1;
                    });
            else if (this.searchType == "MEDICAMENTS")
                return this.$store.getters["app-items/geItemsMED"].filter(item => item.description.toLowerCase().indexOf(q) > -1)
                    .sort((a, b) => {
                        const indexA = a.description.toLowerCase().indexOf(q);
                        const indexB = b.description.toLowerCase().indexOf(q);
                        if (indexA === indexB) {
                            return 0;
                        }
                        return indexA < indexB ? -1 : 1;
                    });
            else return this.$store.getters["app-items/geItemsPARA"].filter(item => item.description.toLowerCase().indexOf(q) > -1)
                .sort((a, b) => {
                    const indexA = a.description.toLowerCase().indexOf(q);
                    const indexB = b.description.toLowerCase().indexOf(q);
                    if (indexA === indexB) {
                        return 0;
                    }
                    return indexA < indexB ? -1 : 1;
                });
        },
        allProducts() {
            if (this.searchType == "TOUS")
                return this.$store.getters["app-items/geItems"];
            else if (this.searchType == "MEDICAMENTS")
                return this.$store.getters["app-items/geItemsMED"];
            else
                return this.$store.getters["app-items/geItemsPARA"]
        },
        paginated() {
            if (this.search.trim() == "")
                return [];
            return this.filtered.slice(0, this.limit)
        },
        hasNextPage() {
            return this.paginated.length < this.filtered.length
        },
        isSearchPending() {
            return this.search.trim() !== this.debouncedSearch.trim()
        },
    },
    mounted() {
        this.observer = new IntersectionObserver(this.infiniteScroll)
    },
    beforeDestroy() {
        if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer)
        if (this.timeout) clearTimeout(this.timeout)
    },
    watch: {
        selected(val) {
            if (val) {
                this.$emit("productClicked", val);
                this.search = "";
                this.selected = null;
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.$refs["select"].$el.querySelector("input").focus();
        });
    },
    methods: {
        async handleSearch(query) {
            this.search = query;
            if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = setTimeout(() => {
                this.debouncedSearch = query;
            }, 300);

            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(async () => {
                if (query.trim().length >= 4) {
                    await this.fetchInventoryData();
                    this.itemKey += 1;
                }
            }, 500);
        },
        async fetchInventoryData() {
            try {
                for (const element of this.paginated) {
                    if (!this.inventoryFetched(element)) {
                        const response = await this.$http.get('_item/inventory/' + element.code + '/1');
                        // console.log(response);
                        if (response.data.status == 200) {
                            element.inventory = response.data.result.Quantity_available;
                            element.fetchedTime = new Date();  // Adding fetchedTime attribute when fetching
                        } else {
                            element.inventory = false;
                        }
                        this.$forceUpdate();
                    }
                }
            } catch (error) {
                console.error('Error fetching inventory data:', error);
            }
        },
        inventoryFetched(element) {
            if (element.inventory !== undefined && element.fetchedTime) {
                const currentTime = new Date();
                const fetchedTime = new Date(element.fetchedTime);
                const timeDiff = (currentTime - fetchedTime) / 60000;  // Convert milliseconds to minutes
                return timeDiff < 10;  // Check if fetchedTime is less than 10 minutes
            }
            return false;
        },
        highlightSearchText(text) {
            const regex = new RegExp(this.search, 'gi');
            return text.replace(regex, match => `<b>${match}</b>`);
        },
        async onOpen() {
            if (this.hasNextPage) {
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
            }
        },
        onClose() {
            this.observer.disconnect();
            this.limit = 10;
            this.debouncedSearch = this.search;
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent
                const scrollTop = target.offsetParent.scrollTop
                this.limit += this.limit
                await this.$nextTick()
                ul.scrollTop = scrollTop
            }
        },
    },
}

</script>

<style lang="scss">
.loader {
    text-align: center;
    color: #bbbbbb;
}

.description {
    display: inline-block;
    width: 70%;
    /* Ajustez la largeur selon vos besoins */
}

.searchTypeSuccess .vs__dropdown-toggle {
    border-color: #28c76f !important;
}

.searchTypePrimary .vs__dropdown-toggle {
    border-color: #7367f0 !important;
}

.links {
    display: inline-block;
    width: 30%;
    /* Ajustez la largeur selon vos besoins */
    text-align: right;
}

.sub-badge {
    cursor: pointer;
}
.sub-badge:hover {
    filter: brightness(0.9);
}
</style>